<template>
<div>
  <!-- containing scrollama object -->
  
  <Scrollama
    :offset="0.5"
    @step-enter="stepEnterHandler"
    @step-exit="stepExitHandler"
    :progress="true"
    @step-progress="progressHandler"  >

    <div class="graphicContainer" slot="graphic">
      <img class ="graphic" :src="assetSrc" rel="preload"/>
      <!--
      <div ref="prevNarrative" class="narrative">
        {{prevNarrativeSrc}}
      </div>
      -->

      <div ref="theFixer" v-if="!showNarrative[currentStep] && (currentStep < steps.length) "  class="fixer narrative" >
        {{getNarrative(currentStep)}}
      </div>
      
    </div>

    <div class="step customstep" :data-step="k" v-for="k in steps">
      <div :class="classes(k)" :ref="`narr-${k}`">
        {{getNarrative(k)}}
      </div>
    </div>
    

    
    <div class="filler" :data-step="content.assets.length"/>
    
  </Scrollama>
  
</div>
</template>

<script>
import Scrollama from 'vue-scrollama'
import anime from 'animejs/lib/anime.es.js'


export default {
  name:"BaseSection",
  props:{
    content: {assets:Array()},
    stepSpeed:1
  },
  components: {
    Scrollama,
  },
  data() {
    return {
      element: null,
      currentStep: 0      
    }
  },
  
  methods: {
    getNarrative(id){
      let myN = this.content.narrative
      if(myN)
        return myN[Math.min(id,myN.length-1)]
      return null
    },   
    
    stepExitHandler({element,index,direction}){
      //this.currentStep = null
    },
    
    stepEnterHandler({ element, index, direction }) {
      this.currentStep = index;
    },
    progressHandler(pp) {
      this.currSetProgress = pp
    },
    stepClass(){
      return {
        step:true,
        mystep:true,
        fast: this.stepSpeed!==1?true:false
      }
    },
    classes(k){
      let imNew = this.showNarrative[k]
      let imPrevious = k==this.currentStep-1
      let fixerIncoming = imPrevious && !this.showNarrative[this.currentStep]
      let fixerOutgoing = imPrevious && this.showNarrative[this.currentStep]
      let hideMe = ((!imNew) || fixerIncoming)
      return {'narrative':true,              
              'hidden': (this.getNarrative(k).length==0) || ((hideMe && !fixerOutgoing) && !(this.currentStep > this.content.narrative.length))
             }
    }    
  },
  computed: {
    steps(){      
      return [...Array(Math.max(this.content.assets.length,this.content.narrative.length)+1).keys()]
    },
    assetSrc() {
      let myAss = this.content.assets
      if(myAss)
        return myAss[Math.min(this.currentStep,myAss.length-1)]
    },
    showNarrative() {
      let out = this.steps.map((s)=>this.getNarrative(s))
      let visibilities = out.reduce( (acc,cur,idx)=>{ return [...acc, (cur.length===0) ? false : (idx===0 ? true : !(out[idx-1]===cur)) ] },Array())

      return visibilities      
    },

  }
}
</script>

<style src="vue-scrollama/dist/vue-scrollama.css"></style>
<style lang="scss" scoped>

  .narrative {
    position:sticky;
    top:7%!important;
    left: calc(50vw - 30ch);
    font-size: calc(min(min(2.5vh,32px),2vw));
    border: 4px solid  #1e2343;
    z-index:10000;
    border-radius:6px;
    font-weight: bold;
    width:60ch!important;
    margin: 0!important;
    padding: 2vw!important;
    background-color:rgba(255,255,255,.876);
}

.fixer{
    position: fixed;
    left: calc(50vw - 30ch);
    opacity:1!important;
}

.hidden{
    opacity:0;
    visibility:hidden;
}

.customstep {
    height: 100vh; 
    z-index:-1000;   
}

</style>
